import { Box, Button, Grid2 } from '@mui/material';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { useState } from 'react';
import { Grid_Gap, Input_Width } from '../../shared/constants';
import useAuthStore from '../../store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import CustomDivider from '../../shared/utils/CustomDivider';
import useClusterZoneStore from '../../store/useClusterZoneStore';
import UtItem from '../../shared/utils/UtList';
import { useClusterColumnsWithDialog } from '../../shared/utils/useClusterColumnsWithDialog';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { useApartmentOptions } from './option/ApartmentOption';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';
import { useClusterOptions } from './option/ClusterOption';
import api from '../../assets/nodeApi/axiosInstance';
import { LocationFilterFields } from '../../shared/components/LocationFilterFields';

const CluserHeadList = () => {
    const { clusterColumns, viewCluster, dialogJSX } = useClusterColumnsWithDialog(true);
    const [filters, setFilters] = useState({});
    const { showToaster } = useToaster();
    const { clusterzone, clearClusterZone } = useClusterZoneStore();
    const { user, token } = useAuthStore();
    const queryClient = useQueryClient();
    const { AddedClusterOptions } = useClusterOptions(filters)
    const { courseApartmentOption } = useApartmentOptions()
    const ApartmentOptions = courseApartmentOption?.options
   
    const validationSchema = Yup.object().shape({
        cluster_name: Yup.string().required("Cluster name is required"),
        zone_id: Yup.string().required("Zone is required"),
        country_id: Yup.string().required("Country is required"),
        state_id: Yup.string().required("State is required"),
        city_id: Yup.string().required("City is required"),
    });
      const initialValues = {
        cluster_name: clusterzone?.cluster_name || "",
        zone_id: clusterzone?.zone_id || "",

        country_id:
            user?.role === "Marketing Manager"
                ? user?.country_id || ""
                : clusterzone?.country_id || "",

        state_id:
            user?.role === "Marketing Manager"
                ? user?.state_id || ""
                : clusterzone?.state_id || "",

        city_id:
            user?.role === "Marketing Manager"
                ? user?.city_id || ""
                : clusterzone?.city_id || ""
    };

    const mutation = useMutation({
        mutationFn: (formData) => {
            return clusterzone?.id
                ? api.put(`clusters/update/${clusterzone?.id}`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                : api.post(`clusters/create`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['clusters'] });
            clearClusterZone()
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const payload = {
            zone_id: Number(values.zone_id),
            state_id: Number(values.state_id),
            ...values
        }
        mutation.mutate(payload, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }

    const [selectedApart, setSelectedApart] = useState([])
    const handleRemove = (id) => {
        setSelectedApart(prev => prev.filter(apartment => apartment.id !== id));
    };

    const mutationAssign = useMutation({
        mutationFn: (formData) => {
            return api.put(`assign-apartments-to-cluster`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            setSelectedApart([])
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });

    const handleSubmitApartEdit = (values, { setSubmitting, resetForm }) => {

        if (selectedApart.length === 0) {
            showToaster('Add Atleast one Cluster', "Warning", 'warning');
            return;
        }
        const obj = {
            cluster_id: String(values?.cluster_id),
            apartment_ids: selectedApart.map(apartment => apartment.id)
        }
        mutationAssign.mutate(obj, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }


    return (
        <>
            {user.role !== "Zonal Coordinator" &&
                <NormalContainerWithHeader headerText={"Create Cluster"}>
                    <Formik

                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {({ resetForm }) => (
                            <Form>
                                <Grid2 container spacing={Grid_Gap}>
                                    <Grid2 children size={Input_Width}>
                                        <Field
                                            name="cluster_name"
                                            component={TextFormField}
                                            label="Enter Cluster Name"
                                            isRequired={true}

                                        />
                                    </Grid2>
                                    <LocationSelectorField
                                        countryField="country_id"
                                        stateField="state_id"
                                        cityField="city_id"
                                        isStoredId={true}
                                        zoneField="zone_id"
                                        isProfile={false}
                                        Input_Width={Input_Width}
                                        isZone={true}
                                        {...(user?.role === "Marketing Manager"
                                            ? {
                                                passedCityId: user?.city_id,
                                                passedCountryId: user?.country_id,
                                                passedStateId: user?.state_id,
                                            }
                                            : {
                                                passedCityId: clusterzone?.city_id,
                                                passedStateId: clusterzone?.state_id,
                                                passedCountryId: clusterzone?.country_id,
                                                passedZoneId: clusterzone?.zone_id,
                                            })}
                                        isPincode={false}


                                    />





                                </Grid2>
                                <CustomDivider />
                                <Grid2 container spacing={Grid_Gap} sx={{justifyContent:"end"}}>
                                    <Grid2 children size={{xs: 12, sm: 6, md: 3}}>
                                        <Button variant='outlined' type="button" onClick={() => { resetForm(); clearClusterZone() }} fullWidth>
                                            Reset
                                        </Button>
                                    </Grid2>
                                    <Grid2 children size={{xs: 12, sm: 6, md: 3}}>
                                        <Button variant="contained" type="submit" fullWidth> {Object.keys(clusterzone).length === 0 ? "Submit" : "Update"} </Button>
                                    </Grid2>
                                </Grid2>
                            </Form>
                        )}
                    </Formik>
                </NormalContainerWithHeader>

            }

            <CustomDivider />
            <NormalContainerWithHeader headerText={"Assign Clusters To Apartment"}>
                <Formik
                    initialValues={{
                        cluster_id: "",
                        apartment_ids: ""
                    }}
                    validationSchema={Yup.object().shape({})}
                    onSubmit={handleSubmitApartEdit}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, resetForm }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 size={12}>
                                    <Box sx={{ display: "flex", gap: 1, my: 2 }}>

                                        {selectedApart?.map((item, index) => (
                                            <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />

                                        ))}
                                    </Box>
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="cluster_id"
                                        component={IdAutoCompleteField}
                                        options={AddedClusterOptions.options}
                                        label="Select Cluster"
                                        isRequired={true}
                                        isLoading={AddedClusterOptions.isLoading}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="apartment_ids"
                                        component={IdAutoCompleteField}
                                        options={ApartmentOptions}
                                        label="Select Apartment"
                                        isRequired={true}
                                        isLoading={courseApartmentOption.isLoading}
                                        onValueChange={(newValue) => {
                                            setSelectedApart((prev) => {
                                                const exists = prev.find((item) => item.id === newValue.id);
                                                return exists ? prev : [...prev, newValue];
                                            });
                                            setFieldValue("apartment_ids", "")
                                        }}
                                    />
                                </Grid2>
                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap} sx={{justifyContent:"end"}}>
                                <Grid2 children size={{xs: 12, sm: 6, md: 3}}>
                                    <Button variant='outlined' type="button" onClick={resetForm} fullWidth>
                                        Reset
                                    </Button>
                                </Grid2>
                                <Grid2 children size={{xs: 12, sm: 6, md: 3}}>
                                    <Button variant="contained" type="submit" fullWidth> Submit </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <CustomDivider />
            <TableFilterTemplate
                title="Cluster List"
                columns={clusterColumns}
                rowsData={AddedClusterOptions.options || []}
                isLoading={AddedClusterOptions.isLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                dataGridProps={{
                    onRowClick: (params) => viewCluster(params.row)
                }}
                renderFilterFields={() => (
                    <>
                        <LocationFilterFields
                            countryField="country_id"
                            stateField="state_id"
                            cityField="city_id"
                            zoneField="zone_id"
                            isStoredId={true}
                        />
                    </>
                )}
            />
            {dialogJSX}
        </>

    )
}

export default CluserHeadList